// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.inventory.reconciliation.ReconciliationItemResponse */
/* istanbul ignore next */
@GandalfModel
export class ReconciliationItemResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	countedItems!: number | null;

	@GandalfProperty({ designType: String })
	itemDescription!: string | null;

	@GandalfProperty({ designType: String })
	itemSku!: string | null;

	@GandalfProperty({ designType: String })
	itemUpc!: string | null;

	@GandalfProperty({ designType: String })
	notes!: string | null;

	@GandalfProperty({ designType: String })
	productCategoryName!: string | null;

	@GandalfProperty({ designType: String })
	productManufacturerName!: string | null;

	@GandalfProperty({ designType: String })
	productName!: string | null;

	@GandalfProperty({ designType: Number })
	reconciledItems!: number | null;

	@GandalfProperty({ designType: Number })
	reportedItems!: number | null;

}
